module.exports = __webpack_public_path__ + "static/img/2.2706a8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncq/2.png
// module id = kE0j
// module chunks = 1